export const SETERR = 'SETERR';
export const SETPHONE = 'SETPHONE';
export const SETAUTOLOGIN = 'SETAUTOLOGIN';
export const SETPOSTURL = 'SETPOSTURL';
export const SETISSHOWEDNEWSCHEMETOAST = 'SETISSHOWEDNEWSCHEMETOAST';